import React, { useRef, useEffect } from 'react';
import { useAdpAnalytics } from '@innovyze/stylovyze';
import { useAssistantMessaging } from './useAssistantMessaging';

const AutodeskAssistant = () => {
  useAssistantMessaging();
  const adpClient = useAdpAnalytics();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const uiHost = containerRef.current;
    if (!uiHost || !adpClient) return;

    adpClient.showAssistant({
      container: uiHost,
      urlSearchParameters: { notitle: 'true' },
    });
  }, [adpClient]);

  return (
    <div
      ref={containerRef}
      style={{
        height: '100%',
        width: '100%',
      }}
    />
  );
};

export default AutodeskAssistant;
